
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "TBS_classification",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/TBS_classification.vue